import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-listgroup-example',
  templateUrl: './listgroup.component.html',
})
export class KitBootstrapListgroupExampleComponent {}
